import type { ServiceConfigFactory } from '../../types'

export default (({ viewerHandlers }) => {
	return {
		navigateTo: viewerHandlers.navigateTo,
	}
}) as ServiceConfigFactory
